import React, { FC, useMemo } from "react";

import { faArrowDownAZ } from "@fortawesome/pro-solid-svg-icons/faArrowDownAZ";
import { faRankingStar } from "@fortawesome/pro-solid-svg-icons/faRankingStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import SegmentedSwitch from "@app/component/input/SegmentedSwitch";
import SortOrder from "@app/scene/dashboard/components/Sidebar/enum/SortOrder";

import styles from "./SortSwitch.module.scss";

interface Props {
  className?: string;
  onChange?: (sortOrder: SortOrder) => void;
  value: SortOrder;
}

const SortSwitch: FC<Props> = ({ className, onChange, value }) => {
  const intl = useIntl();

  const options = useMemo(
    () => [
      {
        label: <FontAwesomeIcon className={styles.icon} icon={faRankingStar} />,
        value: SortOrder.RANK,
      },
      {
        label: <FontAwesomeIcon className={styles.icon} icon={faArrowDownAZ} />,
        value: SortOrder.NAME,
      },
    ],
    []
  );

  return (
    <Tooltip
      title={intl.formatMessage({
        id: "dashboard.sidebar.sortSwitch.tooltip",
        defaultMessage: "Sort order",
        description: "Tooltip of the Sort Switch in Dashboard page's sidebar",
      })}
    >
      <SegmentedSwitch<SortOrder>
        className={className}
        onChange={onChange}
        options={options}
        size="middle"
        value={value}
      />
    </Tooltip>
  );
};

export default SortSwitch;
